<template>
  <div>
    <v-snackbar v-model="showError" :timeout="timeout" color="red">
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="showError = false">
          Close
        </v-btn>
      </template>
      <p v-for="(error, index) of errors" :key="index">
        {{ error }}
      </p>
    </v-snackbar>
    <v-overlay z-index="10000" :value="loading">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
    <storage-list :storages="storages"></storage-list>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('storage');
import StorageList from './Storage/StorageList.vue';
export default {
  components: {
    StorageList
  },
  name: 'Storage',
  async created() {
    await this.getStorages();
  },
  data() {
    return {
      timeout: 5000,
      showError: true
    };
  },
  methods: {
    ...mapActions(['getStorages'])
  },
  computed: {
    ...mapState(['storages', 'loading', 'errors'])
  },
  watch: {
    errors(newValue, oldValue) {
      console.log(`Updating from ${oldValue.length} to ${newValue.length}`);
      if (newValue.length > 0) {
        this.showError = true;
      } else {
        this.showError = false;
      }
    }
  }
};
</script>

<style></style>
